module.exports = __webpack_public_path__ + "./img/logo.cd74d35967142c2ca0a9efb27a7142a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = ./src/assets/img/logo.png
// module chunks = 11